export default {
	subtitle: "Webhooks related to customer/payers",
  	path: "webhooks_related_customer_payers",
	paragraph: "When an unregistered customer makes a bank transfer to the bank account we opened for you, we will send a notification with the customer’s information. You must register this person or company to access the funds from that transaction. If you do not complete the registration, the payment will be refunded within two business days. Once you register this individual or company, we will send you a notification with 'type': 'identified' and the transaction ID. The funds will then be made available in your account. ",
	request: {
		method: "POST",
		payloads: [
		{
		title: "Notification",
		content: { 
		"notification": {
				type: "non_identified_bank_transaction",
				bank_transaction: {
					id: "id of the non identified transaction",
					value: "5000.0",
					currency: "BRL",
					movement_date: "2024-01-05",
					bank_account_id: "your unregistered customer bank account id",
					paid_at: "2024-01-05T06:38:56.367425",
					spei_concepto_de_pago: "when informed by payer. Only applicable to Mexican transactions",
					subject: {
						document_number: "93111817067",
						document_type: "cpf",
						name: "António Elias",
						bank_account: {
							bank: "033",
							branch_number: "0001",
							account_number: "000001",
							account_type: "conta-corrente"
						}
					}
				}
				}
			 }
		  }
		]
	}
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/WebHook/WebhooksRelatedCustomer.js